enum WhosNext {
    Videndum = "Videndum",
    Reporter = "Reporter"
}

export default WhosNext;